<div class="confirm-modal ig-modal travel-buddy-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div>
        <div class="title">
            <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt="travel buddy" class="m-r-1"
                 width="22px" height="22px" matTooltip="Travel Buddy Settings!">Travel Buddy! <span> -
            {{ account.account.userName }}</span>
        </div>

        <mat-tab-group #tab (selectedIndexChange)="changeTab($event)">
            <mat-tab>
                <ng-template mat-tab-label>
                    Settings
                </ng-template>
                <ig-spinner *ngIf="loading"></ig-spinner>
                <div class="m-t-3">
                    <ig-row class="text-left">
                        <ig-col [xs]="12" [md]="12" *ngIf="!loading">
                            <mat-slide-toggle *ngIf="!loading" [(ngModel)]="settings.isActive"
                                              (change)="toggleTravelBuddy()">
                                AI TravelBuddy {{ settings.isActive ? '(On)' : '(Off)' }}
                            </mat-slide-toggle>
                            <mat-slide-toggle *ngIf="!loading" [(ngModel)]="isNewVersion"
                                              (change)="toggleVersion()" style="margin-left: 12px;">
                                New Version {{ settings.version === 'new' ? '(On)' : '(Off)' }}
                            </mat-slide-toggle>
                        </ig-col>
                        <ig-col [xs]="12" [md]="12" *ngIf="!loading && settings.isActive"
                                style="margin:8px 0;padding-left: 0">
                            <mat-slide-toggle *ngIf="!loading" [(ngModel)]="settings.showOnAllClientWidgets"
                                              (change)="toggleTravelBuddy()">
                                Show TravelBuddy on All Client Widgets
                                {{ settings.showOnAllClientWidgets ? '(Yes)' : '(No)' }}
                            </mat-slide-toggle>
                            <div style="font-size: 13px;color:gray">Tick this if you want to show TravelBuddy on all
                                client widgets
                                (only for V3). Or you can add travel-buddy="true" in the script that you want to show
                                TravelBuddy only on certain widgets.
                            </div>
                        </ig-col>
                        <ig-col [md]="12">
                            <a href="https://imgoingcalendar.com/how-to-create-travelbuddy-for-client.html"
                               target="_blank">How to setup TravelBuddy for a new client</a>
                        </ig-col>
                    </ig-row>


                    <ng-container *ngIf="settings.isActive">
                        <hr class="m-t-2 m-b-2">
                        <div class="m-t-2 half-width">
                            <ig-field label="OpenAI Api Key" [formControl]="formGroup.get('apikey')"
                                      [(ngModel)]="settings.openAIKey"
                                      placeholder="e.g., sk-proj-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx">
                            </ig-field>
                        </div>
                        <!-- <div class="m-t-2 half-width">
                            <ig-select [(ngModel)]="modelItems" label="Model" (itemSelected)="selectModel($event)">
                            </ig-select>
                        </div> -->
                        <div class="m-t-2 half-width">
                            <ig-field label="City Name & State" [formControl]="formGroup.get('cityName')"
                                      [(ngModel)]="settings.cityName" placeholder="e.g., Savannah, GA">
                            </ig-field>
                        </div>
                        <div class="m-t-1">

                            <mat-tab-group #tab (selectedIndexChange)="changeTab($event)">
                                <mat-tab>
                                    <ng-template mat-tab-label>
                                        For Current Version
                                    </ng-template>
                                    <div>
                                        <div class="half-width">
                                            <ig-field label="OpenAI assistant id" [formControl]="formGroup.get('assistantId')"
                                                      [(ngModel)]="settings.openAIAssistant.id" [readonly]="true">
                                            </ig-field>
                                        </div>
                                        <div style="width:180px" class="flex gap-2">
                                            <ig-button size="md" (trigger)="createAssistant($event)" [isAsync]="true"
                                                       [disabled]="!formGroup.get('apikey').value || !formGroup.get('cityName').value || settings.openAIAssistant.id">
                                                Create Assistant
                                            </ig-button>
                                            <ig-button [disabled]="!settings.openAIKey || !settings.openAIAssistant.id"
                                                       [isAsync]="false"
                                                       [class.red-btn]="settings.openAIKey && settings.openAIAssistant.id"
                                                       matTooltip="After deleting the assistant here, you need to delete the OpenAI key and project on OpenAI website. Please refer to the link above for more details."
                                                       (trigger)="deleteAssistant()">Delete
                                                Assistant
                                            </ig-button>
                                        </div>
                                    </div>
                                    <div class="m-t-3">
                                        <p class="text-left">Event file upload time: {{ getEventFileUploadTime() }}</p>
                                        <p class="text-left">Place file upload time: {{ getPlaceFileUploadTime() }}</p>
                                        <ig-button [isAsync]="true" size="md" (trigger)="uploadFiles($event)"
                                                   style="width:160px;margin-top: 12px">Re-upload files
                                        </ig-button>
                                    </div>
                                </mat-tab>
                                <mat-tab>
                                    <ng-template mat-tab-label>
                                        For New Version
                                    </ng-template>
                                    <div class="full-width text-left">
                                        <mat-checkbox [(ngModel)]="settings.isStandalone">Standalone Version</mat-checkbox>
                                        
                                        <div class="m-t-3">
                                            <b>Nearby Cities</b>
                                            <div class="flex items-center m-b-2">
                                                <ig-city-selector 
                                                    [(ngModel)]="newCity" 
                                                    [placeholder]="'Add a nearby city'"
                                                    style="width: 100%; max-width: 300px; margin-right: 10px;">
                                                </ig-city-selector>
                                                <ig-button 
                                                    [disabled]="!newCity" 
                                                    (trigger)="addNearbyCity()"
                                                    style="width: 100px;">
                                                    Add City
                                                </ig-button>
                                            </div>
                                            
                                            <div *ngIf="settings.nearbyCities?.length > 0" style="transform:translateY(-20px)">
                                                <b style="margin-bottom: 8px;">Current Nearby Cities:</b>
                                                <mat-chip-list>
                                                    <mat-chip *ngFor="let city of settings.nearbyCities" [removable]="true" (removed)="removeNearbyCity(city)">
                                                        {{city.city}}, {{city.state}}
                                                        <mat-icon matChipRemove>cancel</mat-icon>
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </div>
                                        </div>
                                        
                                        <p class="m-t-3" style="margin-bottom: 4px;">Enter dedicated prompt for this account</p>
                                        <textarea label="OpenAI assistant id"
                                                  [(ngModel)]="settings.clientPrompt" style="height: 200px;width:99%">
                                        </textarea>
                                    </div>

                                    <ig-button [isAsync]="true" size="md" (trigger)="saveNewSettings($event)"
                                                   style="width:160px;margin: 12px 0">Save
                                        </ig-button>
                                </mat-tab>
                            </mat-tab-group>
                           
                        </div>

                        

                    </ng-container>
                </div>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    Report
                </ng-template>
                <ig-spinner *ngIf="loadingReport"></ig-spinner>
                <div class="m-t-3" *ngIf="selectedTabIndex===1 && !loadingReport">

                    <div *ngIf="!getKeys(reports).length">No report available</div>

                    <div style="max-height:600px;overflow:auto">
                        <div *ngFor="let month of getKeys(reports)" class="text-left m-b-5">
                            <p style="font-size:18px;font-weight:bold">{{ month }}</p>
                            <div class="m-l-3">Total users: {{ getKeys(reports[month]).length }}</div>
                            <div class="m-l-3">Average response time: {{ calculateAverageTimeByMonth(reports[month]) }}s
                            </div>
                            <!-- <div *ngFor="let user of getKeys(reports[month])" class="m-l-3">
                                <h4>User: {{ user }}</h4>
                                <p>Total converstions: {{ reports[month][user].length }}</p>
                                <p>Average time consumed: {{ calculateAverageTime(reports[month][user]) }}</p>
                            </div> -->
                        </div>
                    </div>

                    <div id="travel-buddy-report-chart" class="p-r-3"></div>
                </div>
            </mat-tab>
            
            <mat-tab>
                <ng-template mat-tab-label>
                    Trip Planner V3 Key
                </ng-template>
                <ig-spinner *ngIf="loadingReport"></ig-spinner>
                <div class="m-t-3" *ngIf="!loadingTripPlannerSettings">

                    <ig-field label="OpenAI Api Key" [formControl]="tripPlannerForm.get('openAIKey')"
                                      [(ngModel)]="tripPlannerSettings.openAIKey" style="width:60%"
                                      matTooltip="This will be used to generate the AI suggested trips for users">
                            </ig-field>

                    <ig-button [isAsync]="true" size="md" (trigger)="saveTripPlannerSettings($event)"
                               style="width:160px;margin-top: 12px">Save
                    </ig-button>

                </div>
            </mat-tab>
        </mat-tab-group>


        <!-- <div class="action-row flex">
            <ig-button class="m-l-2" color="cancel" (trigger)="close()">
                Cancel
            </ig-button>
            <ig-button size="md" [isAsync]="true" [disabled]="!formGroup.valid" (trigger)="confirm($event)">
                Save
            </ig-button>
        </div> -->
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/travel.buddy.settings/travel.buddy.settings.modal.component.html